import { append, equals, lensProp, over, reject } from 'ramda';
import { useLayoutStore } from './store';

export const actionsCreator = ({ setState }: typeof useLayoutStore) => ({
  SET_COMPONENT_EXPANDED: (expandedComponentId: string) =>
    setState(
      over(lensProp('expandedComponentIds'), append(expandedComponentId))
    ),

  UNSET_COMPONENT_EXPANDED: (expandedComponentId: string) =>
    setState(
      over(
        lensProp('expandedComponentIds'),
        reject(equals(expandedComponentId))
      )
    )
});

export const layoutActions = actionsCreator(useLayoutStore);
